import React, { FC } from 'react'
import SALink from 'components/SALink'
import Skeleton from 'components/SA/Skeleton'
import useAvoidLayoutShift from 'hooks/useAvoidLayoutShift'
import useQA from 'hooks/useQA'

import styles from './Breadcrumb.module.scss'

export type BreadcrumbLink = {
  name: string
  url?: string
  title: string
}

type BreadcrumbProps = {
  items: ReadonlyArray<BreadcrumbLink>
}

const Breadcrumb: FC<BreadcrumbProps> = ({ items }) => {
  const { isSkeletonVisible } = useAvoidLayoutShift()
  const { testId } = useQA()

  return (
    <nav className={styles.breadcrumbContainer}>
      {isSkeletonVisible ? (
        <Skeleton width='150px' height='21px' />
      ) : (
        <ul {...testId('breadcrumb-ul')}>
          {items.map(({ name, url, title }, index) =>
            Boolean(url) ? (
              <li key={`bc-${index}`}>
                <SALink title={title} href={url} key={`${name}-${index}`}>
                  {name}
                </SALink>
              </li>
            ) : (
              <li key={`bc-${index}`}>
                <span key={`${name}-${index}`}>{name}</span>
              </li>
            )
          )}
        </ul>
      )}
    </nav>
  )
}

export default Breadcrumb
